import { render } from "./DeleteDashboard.vue?vue&type=template&id=424d8576"
import script from "./DeleteDashboard.vue?vue&type=script&lang=js"
export * from "./DeleteDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__